import React from 'react';
import "./Validation.scss";
import logo from "../../images/logorouge.png";
import { useHistory } from 'react-router-dom';

const Validation = () => {
    const history = useHistory();
    return (
        <>
        <div className="everyat">
             <div className="imgo"> <img src={logo} alt="logo" /></div>
             <div className="h3pd">Merci d'avoir consacré du temps pour ton avenir ! Ton inscription sur le site</div>
             <div className="h3pd">StudentBank a bien été validée ! Nos équipes ont hâte de travailler avec toi !</div>
             <div className="buttoninscritjk" onClick={()=>history.push("/")}>RENTRER A L'ACCUEIL</div>
             </div>
        </>
    )
}

export default Validation
